module.exports = __webpack_public_path__ + "media/images/people/boy-3-55ac3f4210489731f1d8c33c3c1b310b.webp";